/**
 * GoogleAdsInit.jsx - Initializes Google Tag for Google Ads.
 *
 * Enabled with REACT_APP_GOOGLE_ADS_ID, for example AW-18363268164.
 * Conversion events remain disabled until the conversion label is configured.
 */
import { useEffect, useRef } from 'react';
import { getGoogleAdsId, hasGoogleAdsConfig } from './googleAds';

export default function GoogleAdsInit() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current || !hasGoogleAdsConfig()) return;
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const adsId = getGoogleAdsId();
    const existing = document.querySelector(`script[data-iv1-google-ads="${adsId}"]`);

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag(){ window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', adsId);

    if (!existing) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(adsId)}`;
      script.setAttribute('data-iv1-google-ads', adsId);
      document.head.appendChild(script);
    }

    try {
      window.__googleAdsActive = true;
      window.__googleAdsId = adsId;
      window.__googleAdsEvents = window.__googleAdsEvents || [];
    } catch (_) {}

    initialized.current = true;
  }, []);

  return null;
}
